import { Component, OnInit } from '@angular/core';
import { Dialog } from 'primeng/dialog';

@Component({
    selector: 'app-webtime-portlet',
    templateUrl: './webtime-portlet.component.html'
})
export class WebTimePortletComponent implements OnInit {

    constructor() { }

    ngOnInit(): void { }

    showDialogMaximized(dialog: Dialog) {
        dialog.maximize();
    }
}
